
import { Component, namespace, Prop, Vue } from 'nuxt-property-decorator'

import { namespace as baseInfoStore, GetterType as BaseInfoGetterType, BaseInfoState } from '~/store/modules/BaseInfo'
import { OnMounted } from '~/core/vue.types'

import NetworkFilter from '~/components/sections/coverage/filter/NetworkFilter.vue'
import CoverageFilter from '~/components/sections/coverage/filter/CoverageFilter.vue'
import CoverageMapCanvas from '~/components/sections/coverage/CoverageMapCanvas.vue'
import { NetworkName, NetworkType } from '~/components/sections/coverage/types'

const BaseInfoStore = namespace(baseInfoStore)

@Component({
  components: {
    NetworkFilter,
    CoverageFilter,
    CoverageMapCanvas,
  },
})
export default class CoverageMap extends Vue implements OnMounted {
  @Prop({ required: false, default: '', type: String })
  private readonly selectedProviderByDefault!: string

  @Prop({ required: true, type: String })
  private readonly title!: string

  private selectedProviderId = 0
  private selectedNetworkType: NetworkType = '4G'
  private countryCode = 'CH'
  private currentLocation: GeolocationCoordinates | null = null

  private place: google.maps.places.PlaceResult | Record<string, any> = {}

  @BaseInfoStore.Getter(BaseInfoGetterType.ACTIVE_PROVIDERS)
  partnersList!: BaseInfoState['providers']

  get selectedProvider () {
    return this.partnersList.find(p => p.id === this.selectedProviderId) || this.partnersList[0]
  }

  get selectedProviderNetwork (): NetworkName {
    return this.selectedProvider.mobile_network.toLowerCase() as NetworkName
  }

  get availableNetworkTypesList () {
    return this.selectedProvider.available_networks || []
  }

  onLocationSuccess (location: GeolocationPosition) {
    if (location.coords) {
      this.currentLocation = location.coords
    }
  }

  onLocationError (error: GeolocationPositionError) {
    this.currentLocation = null
    let errorMessage = ''

    switch (error.code) {
      case error.POSITION_UNAVAILABLE:
        errorMessage = this.$t('coverage.errors.positionUnavailable') as string
        break
      case error.PERMISSION_DENIED:
        errorMessage = this.$t('coverage.errors.permissionDenied') as string
        break
      case error.TIMEOUT:
        errorMessage = this.$t('coverage.errors.timeout') as string
    }

    this.$notify({
      title: 'Error',
      message: errorMessage,
      duration: 5000,
    })
  }

  onPlaceChanged (place: google.maps.places.PlaceResult) {
    this.place = place
  }

  selectInitialProvider () {
    if (this.selectedProviderByDefault) {
      const provider = this.partnersList.find(p => p.slug === this.selectedProviderByDefault)

      if (provider) {
        this.selectedProviderId = provider.id
        return
      }
    }

    this.selectedProviderId = this.partnersList[0].id
  }

  mounted () {
    this.selectInitialProvider()
  }
}
